import { Component, OnInit, NgZone } from '@angular/core';
import { DBService } from 'src/app/services/db.service';
import { Reservation } from 'src/app/models/reservation.model';
import { UtilService } from 'src/app/services/util.service';
import { AlertService } from 'src/app/services/alert.service';
import { ReservationService } from 'src/app/services/reservation.service';
import { STORAGE_MY_RESERVATIONS } from '../../../../environments/constant';
import { Router } from '@angular/router';

@Component({
  selector: 'app-reservation-customer',
  templateUrl: './reservation-customer.page.html',
  styleUrls: ['./reservation-customer.page.scss'],
})
export class ReservationCustomerPage implements OnInit {

  reservation: Reservation
  reservationDate: string

  constructor(public db: DBService, private ngZone: NgZone, private router: Router, public util: UtilService, public reservationService: ReservationService,
  private alert:AlertService) { }

  //TODO: Merken der Angaben fuer spaeter
  ngOnInit() {
    if (!this.db.currentRestaurantKey) {
      this.ngZone.run(() => this.router.navigate(['/restaurant-list']))
      return
    }
    this.util.reservationUI = 'overview'
  }

  back() {
    if(this.util.reservationUI == 'create'){
      this.util.reservationUI = 'overview'
    }else{
      this.ngZone.run(() => this.router.navigate(['/customer-home']))      
    }
  }

  createNewReservation() {
    this.util.reservationUI = 'create'
  }

  cancel(reservation: Reservation){
    this.alert.presentAlertConfirm(this, (ref) => {
      //TODO: man könnte es einfach auch nur canceln
      ref.db.myPrivateReservations = ref.util.deleteFromArray(ref.db.myPrivateReservations, reservation)
      localStorage.setItem(STORAGE_MY_RESERVATIONS, JSON.stringify(this.db.myPrivateReservations));
      this.db.deleteReservation(reservation)
    }, 'Reservierung löschen?', 'Möchtest du deine Reservierung wirklich löschen?')
  }

  get myPrivateReservations(){
    return this.db.myPrivateReservations.sort(function(a: Reservation, b: Reservation) {
      if (a.date < b.date) {
        return 1;
      }
      if (a.date > b.date) {
        return -1;
      }
    
      return 0;
    });
  }

}
